import { HTMLAttributes } from 'react';
import { joinClassNames } from '../../utils';
import { Col, ResponsiveBreakpoints, SpanOptions } from '../Grid';
import styles from './styles.module.scss';

export type ModalSectionProps = HTMLAttributes<HTMLDivElement> & {
  variant?: 'primary' | 'secondary';
  span?: SpanOptions | ResponsiveBreakpoints<SpanOptions>;
};

export const ModalSection = ({ children, variant = 'primary', span = 'auto' }: ModalSectionProps) => (
  <Col span={span} excludeBottomGutter>
    <div className={joinClassNames(styles.modalSection, variant !== 'primary' && styles[variant])}>
      {children}
    </div>
  </Col>
);
